<template>
  <div class="dx-top-border dx-card-players">
    <div class="row">
      <div class="col-3 col-sm-2">
        <p class="subtitle">{{ $t('mediator') }}</p>
        <div class="dx-card-players__avatars">
          <dx-player
            :mediator="true"
            :avatar="mediator.avatar"
            :points="mediator.points"
            :user="mediator.user"
            />
        </div>
      </div>
      <div class="col-9">
        <p class="subtitle">{{ $t('players') }}</p>
        <div class="dx-card-players__avatars">
          <div class="row no-gutters">
            <div class="col-3 col-sm-2" v-for="player in players" :key="player.id">
              <dx-player
                :active="player.id === currentPlayer"
                :avatar="player.avatar"
                :points="player.points"
                :user="player.user"
                />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DxPlayer from './DxPlayer.vue'

export default {
  name: 'dx-card-players',
  props: {
    currentPlayer: Number,
    mediator: Object,
    players: Array
  },
  components: { DxPlayer }
}
</script>



// WEBPACK FOOTER //
// src/components/DxCardPlayers.vue